import SimpleModal from "common/Form/Form";
import {
  Box,
  Button,
  Grid,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Card from "common/Cards/CardDetailWithPricing";
import { useTranslation } from "react-i18next";
import CardSummary from "common/Cards/CardSummary";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { ReactComponent as Invoice } from "assets/Modal/invoice.svg";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { InvoiceProfileService } from "subModule/src/core/services";
import { GetInvoiceByIdResponse } from "subModule/src/services/invoice/interface";
import AlertMessages from "common/Alert/AlertMessages";
import Loader from "layout/Loader";
import PersonIcon from "@mui/icons-material/Person";
import { ReactComponent as Call } from "assets/Modal/call.svg";
import { brandingInfo } from "features/server/brandingSlice";
import { useSelector } from "react-redux";
import { themes } from "theme/themes";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DropdownMenu from "common/DropDownMenu/DropDownMenu";
import {
  useGetInvoiceTemplateService,
  useGetReviewByIdService,
} from "subModule/src/services/invoice/useInvoices";
import InvoiceDownloadIcon from "assets/download-invoice";
import { useBusinessSetupEntityBreadcrumbs } from "Helpers/useBusinessSetupEntityBreadcrumbs";
export default function InvoiceModal() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const { breadcrumbItems, captureLabel } = useBusinessSetupEntityBreadcrumbs({
    sectionLabelKey: "customers",
    moduleLabelKey: "invoices",
    moduleHref: "/invoices",
    entityFallbackLabelKey: "invoiceNo",
    isEdit: !!params?.id,
    action: "details",
  });
  const { enqueueSnackbar } = useSnackbar();
  const branding = useSelector(brandingInfo);
  const themeColors =
    branding?.attributes?.themeId === 100
      ? branding?.attributes?.customTheme
      : (themes as any)[branding?.attributes?.themeId || 3];
  const [loading, setLoading] = useState<boolean>(params?.id ? true : false);
  const [reviewLoading, setReviewLoading] = useState<boolean>(true);
  const [invoice, setInvoice] = useState<any>({});
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isScreen900pxOrGreater = useMediaQuery("(min-width:900px)");
  const { data: invoiceTemplatesData, refetch: invoiceTemplatesRefetch } =
    useGetInvoiceTemplateService({ pageNumber: 1, size: 50, type: 2 });
  const { data: reviewByIdData, refetch: reviewByIdFetch } =
    useGetReviewByIdService(Number(params?.id));
  const invoiceTemplates = (
    invoiceTemplatesData?.pages[0]?.data?.content || []
  ).map((item: { id: number; name: string }) => ({
    value: item.id,
    label: item.name,
  }));
  useEffect(() => {
    invoiceTemplatesRefetch();
    setTimeout(() => setReviewLoading(true), 50);
    reviewByIdFetch().finally(() => setReviewLoading(false));
  }, []);
  useEffect(() => {
    if (params?.id && invoiceTemplatesData) {
      if (loading) getByID();
    }
  }, [params, invoiceTemplatesData]);
  useEffect(() => {
    if (reviewByIdData && reviewLoading) setReviewLoading(false);
  }, [reviewByIdData]);
  const getByID = () => {
    InvoiceProfileService.getInvoiceByID(+(params as any)?.id)
      .then((res: GetInvoiceByIdResponse) => {
        if (res.success) {
          setInvoice(res?.data || {});
          const invNo = (res?.data as any)?.invoiceNo;
          captureLabel(invNo != null ? String(invNo) : null);
          setLoading(false);
        } else {
          enqueueSnackbar(
            <AlertMessages text={res.message || "Something went wrong"} />,
            { variant: "error" },
          );
        }
      })
      .catch((err: any) => {
        console.error("===", err);
      });
  };
  // const onExport = async (templateId: number) => {
  //     setDownloading(true);
  //     CommonProfileService.exportEntity({ typeName: `invoices/export/${params?.id}` }, templateId).then((res: Blob) => {
  //     const blob = new Blob([res], { type: 'application/pdf' });

  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', `${invoice[`invoiceNo`]}-${templateId}.pdf`);
  //     document.body.appendChild(link);
  //     link.click();

  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //     enqueueSnackbar(<AlertMessages text={t('template') + ' ' + t('downloadedSuccessfully')} />, { variant: 'success' });
  // }).catch((err) => {
  //     console.error("===", err);
  //     enqueueSnackbar(<AlertMessages statusCode={0} />, { variant: 'error' });
  // }).finally(() => {
  //     setDownloading(false);
  // });
  // };
  return (
    <div>
      <ComponentHeaderTwo
        breadcrumbItems={breadcrumbItems}
        showBtn={true}
        showSaveBtn={false}
        onClick={() => navigate(-1)}
        onSubmit={() => {}}
        heading={t("invoiceDetails")}
        icon={<Invoice height={28} width={28} />}
        btnText={"back"}
        btnType={"back"}
        isBtnEnabled={false}
        showCreateBtn={false}
      />
      {loading || reviewLoading ? (
        <Loader />
      ) : (
        <SimpleModal
          visable={true}
          title={"invoiceDetails"}
          isButtonVisable={false}
          isVisableBtn={false}
          btnclosetext="Back"
          buttonText={""}
          attBtnNotshow={false}
          notVisableBackbtn={true}
          formSubmit={() => {}}
          content={
            <>
              <Box className="text-end">
                <Button
                  id="import-button"
                  variant="contained"
                  disableElevation
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
                    setAnchorEl(event.currentTarget)
                  }
                  endIcon={<KeyboardArrowDownIcon />}
                  className={`bg-white font-Saira font-[600] text-[13px] h-[31px] px-4 py-1 cursor-pointer rounded-[6px] ms-[10px]`}
                  sx={{
                    outline: "2px solid",
                    color: themeColors?.primary,
                    borderColor: themeColors?.primary,
                  }}
                >
                  {t("download")}
                </Button>
                <DropdownMenu
                  anchorEl={anchorEl}
                  menuItems={(invoiceTemplates || []).map(
                    (template: { value: number; label: string }) => ({
                      label: (
                        <Box className="flex items-center gap-2">
                          <InvoiceDownloadIcon
                            primary={themeColors?.primary}
                            secondary={themeColors?.secondary}
                          />
                          {t(template?.label || "")}
                        </Box>
                      ),
                      // onClick: () => onExport(template.value),
                      onClick: () =>
                        navigate(
                          `/invoices/${params?.id}/template/${template.value}`,
                        ),
                    }),
                  )}
                  onClose={() => setAnchorEl(null)}
                  hoverColor={themeColors?.primary}
                />
              </Box>
              <Grid
                container
                sx={{
                  background: "#fff",
                  borderRadius: "8px",
                  margin: "10px 0",
                  padding: "6px 20px",
                }}
              >
                <Grid container xs={12} md={6}>
                  <Grid container xs={12} sm={4}>
                    <Grid xs={12} className="text-left">
                      <Typography className="font-Saira text-black font-[600] line-clamp-1 text-[14px]">
                        {invoice?.vehiclePlateNo ? (
                          <h4 className="font-medium mb-0 text-[12px] ff-primary truncate">
                            {invoice?.attributes?.makeTitle}-
                            {invoice?.attributes?.modelTitle}
                            {invoice?.attributes?.year
                              ? "-" + invoice?.attributes?.year
                              : ""}
                          </h4>
                        ) : (
                          <h4 className="font-medium mb-0 text-[12px] ff-primary truncate">
                            {invoice?.attributes?.cartNo || " "}
                          </h4>
                        )}
                      </Typography>
                    </Grid>
                    <Grid xs={12} className="text-left pr-5">
                      <Tooltip
                        title={
                          invoice?.vehiclePlateNo
                            ? invoice?.vehiclePlateNo
                            : invoice?.invoiceType === 20
                              ? t("directSales")
                              : invoice?.invoiceType === 50
                                ? t("consolidated")
                                : ""
                        }
                      >
                        <div
                          className="h-[40px] border-2 rounded-md px-2 flex items-center justify-center bg-[#E5E5E5]"
                          style={{ borderColor: themeColors?.primary }}
                        >
                          <Typography
                            className="font-Saira line-clamp-1 font-[700] text-[12px]"
                            sx={{ color: themeColors?.primary }}
                          >
                            {invoice?.vehiclePlateNo ? (
                              <span>{invoice?.vehiclePlateNo}</span>
                            ) : invoice?.invoiceType === 20 ? (
                              <span>{t("directSales")}</span>
                            ) : invoice?.invoiceType === 50 ? (
                              t("consolidated")
                            ) : (
                              ""
                            )}
                          </Typography>
                        </div>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    xs={12}
                    sm={6}
                    rowGap={1}
                    className={`relative ${isScreen900pxOrGreater && "left-[32%]"}`}
                  >
                    <Grid xs={12} className="text-left ">
                      <Typography
                        className={`font-Saira italic text-txt-color font-[400] text-[12px] flex gap-1 justify-end ${i18n?.language === "ar" || i18n?.language === "ur" ? "flex-row-reverse" : "flex-row"}`}
                      >
                        {t("invoice") + " " + t("number")}
                        <span> : </span>
                        <span className="font-[700]">
                          {invoice[`invoiceNo`]}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid container xs={12} rowGap={1} className="text-left">
                      <Grid item container xs={8}>
                        <Grid xs={12} sx={{ lineHeight: 0 }}>
                          <Typography className="font-Saira flex italic text-txt-color font-[500] text-[11px] items-center ms-[-3px]">
                            {
                              <PersonIcon className="mr-1 w-[15px] text-[#000]" />
                            }{" "}
                            {invoice?.attributes?.customerName ||
                              invoice?.attributes?.companyName ||
                              t("N/A")}
                          </Typography>
                        </Grid>
                        <Grid container xs={12}>
                          <Typography className="font-Saira flex italic text-txt-color font-[500] text-[11px]">
                            {
                              <Call
                                height={"12px"}
                                className="mt-[2px] mr-1"
                                width={"12px"}
                              />
                            }{" "}
                            {invoice?.attributes?.customerPhone || t("N/A")}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} sm={6}>
                  <Grid xs={12}>
                    <Box
                      className={`font-Saira text-txt-color font-[500] text-[12px] flex gap-1 justify-self-end ${i18n?.language === "ar" || i18n?.language === "ur" ? "flex-row-reverse" : "flex-row"}`}
                    >
                      <span className="italic">{t("vehicleNumber")}</span>
                      <span>:</span>
                      <span className="font-Saira italic text-black font-[700]">
                        {invoice?.vehicleVin || t("N/A")}
                      </span>
                    </Box>
                  </Grid>
                  <Grid xs={12}>
                    <Box
                      className={`font-Saira text-txt-color font-[500] text-[12px] flex gap-1 justify-self-end ${i18n?.language === "ar" || i18n?.language === "ur" ? "flex-row-reverse" : "flex-row"}`}
                    >
                      <span className="italic">{t("creditAmount")}</span>
                      <span>:</span>
                      <span className="font-Saira italic text-black font-[700]">
                        {new Intl.NumberFormat("en", {
                          notation: "standard",
                          maximumFractionDigits: 2,
                        }).format(invoice?.creditAmount || 0)}
                      </span>
                    </Box>
                  </Grid>
                  <Grid container xs={12}>
                    <Grid xs={12} sm={6}>
                      <span
                        className={`${
                          invoice?.paymentStatus === 777
                            ? "unpaid"
                            : invoice?.paymentStatus === 778
                              ? "partialpaid"
                              : "paid"
                        } px-2 py-1 sm:px-3 sm:py-2 rounded-lg font-medium uppercase text-sm sm:text-[12px] font-Saira`}
                      >
                        {invoice?.paymentStatus === 777
                          ? t("unpaid")
                          : invoice?.paymentStatus === 778
                            ? t("partialPaid")
                            : t("paid")}
                      </span>
                    </Grid>
                    <Grid xs={12} sm={6} className="text-right">
                      <Grid xs={12}>
                        <Box
                          className={`font-Saira text-txt-color mb-[-5px] text-[9px] font-[500] flex gap-1 justify-self-end ${i18n?.language === "ar" || i18n?.language === "ur" ? "flex-row-reverse" : "flex-row"}`}
                        >
                          <span className="italic">{t("station")}</span>
                          <span>:</span>
                          <span className="font-[600]">
                            {invoice?.attributes?.stationName}
                          </span>
                        </Box>
                      </Grid>
                      <Grid xs={12}>
                        <span className="font-Saira italic text-txt-color font-[500] text-[9px]">
                          {t("createdAt") + ":"}
                        </span>
                        <span className="font-Saira text-txt-color font-[600] text-[11px] ml-2">
                          {(() => {
                            const date = new Date(invoice?.createdAt);
                            return isNaN(date.getTime())
                              ? "-"
                              : new Intl.DateTimeFormat(i18n.language, {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  numberingSystem:
                                    i18n.language === "ur" ||
                                    i18n.language === "ar"
                                      ? "arab"
                                      : "latn",
                                }).format(date);
                          })()}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                {invoice?.invoicePackages?.length > 0 && (
                  <Grid item xs={12} className="mt-4 p-2 rounded-lg ml-2">
                    <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2  text-[16px] leading-[24px]">
                      {t("packageDetails")}
                    </Typography>
                    <Grid item xs={12}>
                      <Card
                        data={invoice?.invoicePackages}
                        type="package"
                        typeName="invoice"
                      />
                    </Grid>
                  </Grid>
                )}
                {invoice?.invoiceServices?.length > 0 && (
                  <Grid item xs={12} className="mt-4 p-2 rounded-lg ml-2">
                    <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2  text-[16px] leading-[24px]">
                      {t("serviceDetails")}
                    </Typography>
                    <Card
                      data={invoice?.invoiceServices}
                      type="service"
                      typeName="invoice"
                    />
                  </Grid>
                )}
                {invoice?.invoiceItems?.length > 0 && (
                  <Grid item xs={12} className="mt-4 p-2 rounded-lg ml-2">
                    <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2 text-[16px] leading-[24px]">
                      {t("itemDetails")}
                    </Typography>
                    <Grid item xs={12}>
                      <Card
                        data={invoice?.invoiceItems}
                        type="item"
                        typeName="invoice"
                      />
                    </Grid>
                  </Grid>
                )}

                {invoice?.deliveryNoteResponses?.length > 0 ? (
                  <>
                    {invoice?.deliveryNoteResponses?.map((row: any) => {
                      return (
                        <>
                          {row?.deliveryNotePackages?.length > 0 ? (
                            <>
                              <Grid
                                item
                                xs={12}
                                className="mt-4 p-2 rounded-lg ml-2"
                              >
                                <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2  text-[16px] leading-[24px]">
                                  <span>{t("deliveryNote")} </span>
                                  <span className="italic font-[500] text-[14px]">
                                    {row?.deliveryNoteNo || ""}
                                  </span>
                                  <span> {t("packageDetails")}</span>
                                </Typography>
                                <Grid item xs={12}>
                                  <Card
                                    data={row?.deliveryNotePackages || []}
                                    type="package"
                                    typeName="invoice"
                                  />
                                </Grid>
                              </Grid>
                            </>
                          ) : null}
                          {row?.deliveryNoteServices?.length > 0 ? (
                            <>
                              <Grid
                                item
                                xs={12}
                                className="mt-4 p-2 rounded-lg ml-2"
                              >
                                <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2  text-[16px] leading-[24px]">
                                  <span>{t("deliveryNote")} </span>
                                  <span className="italic font-[500] text-[14px]">
                                    {row?.deliveryNoteNo || ""}
                                  </span>
                                  <span> {t("serviceDetails")}</span>
                                </Typography>
                                <Grid item xs={12}>
                                  <Card
                                    data={row?.deliveryNoteServices || []}
                                    type="service"
                                    typeName="invoice"
                                  />
                                </Grid>
                              </Grid>
                            </>
                          ) : null}
                          {row?.deliveryNoteItems?.length > 0 ? (
                            <>
                              <Grid
                                item
                                xs={12}
                                className="mt-4 p-2 rounded-lg ml-2"
                              >
                                <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2  text-[16px] leading-[24px]">
                                  <span>{t("deliveryNote")} </span>
                                  <span className="italic font-[500] text-[14px]">
                                    {row?.deliveryNoteNo || ""}
                                  </span>
                                  <span> {t("itemDetails")}</span>
                                </Typography>
                                <Grid item xs={12}>
                                  <Card
                                    data={row?.deliveryNoteItems || []}
                                    type="item"
                                    typeName="invoice"
                                  />
                                </Grid>
                              </Grid>
                            </>
                          ) : null}
                        </>
                      );
                    })}
                  </>
                ) : null}
                <CardSummary
                  data={invoice}
                  typeName="invoice"
                  review={reviewByIdData?.data || {}}
                />
              </Grid>
            </>
          }
        />
      )}
    </div>
  );
}
